export const CheckedCircleIcon = () => (
  <svg viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_2645_2914)'>
      <path
        d='M31.0588 16C31.0588 24.3167 24.3167 31.0588 16 31.0588C7.68323 31.0588 0.941162 24.3167 0.941162 16C0.941162 7.68323 7.68323 0.941162 16 0.941162C24.3167 0.941162 31.0588 7.68323 31.0588 16Z'
        fill='currentColor'
      />
      <path
        d='M10 16L13.5 20.5L22.5 11'
        stroke='currentColor'
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_2645_2914'>
        <rect fill='white' />
      </clipPath>
    </defs>
  </svg>
)
